import { Observable } from "rxjs";
import { Injectable } from "@angular/core"
import { RestApiService } from "../rest-api.service"
import { environment } from "src/environments/environment";
import { CommonService } from "../Common.service";
import { HttpClient } from "@angular/common/http";
import { EncryptDecryptService } from "../encrypt-decrypt.service";
import { ITransmittalSerialNoInputModel, ITransmittalMsgInputModel, ITransmittalMsgReceiverInput, ITransmittalGroupMemberInput, ITransmittalMsgDocumentInput, ITransmittalDocumentInput, ITransmittalDocumentCopyInput, ITransmittalDocumentElementDetails, ITransmittalDocumentElementInput, ITransmittalMailDetails, ITransmittalMasterInput, ITransmittalSignedDocumentsModel } from 'src/app/ViewModel/TransmittalModel';

@Injectable({ providedIn: "root" })

export class TransmittalMsgService {
    private endPoints = {
        getTransmittalSerialNo: 'Transmittal/GetTransmittalSerialNo',
        insertUpdateTransmittalDetails: 'Transmittal/InsertUpdateTransmittalDetails',
        insertUpdateTransmittalReceiverDetails: 'Transmittal/InsertUpdateTransmittalReceiverDetails',
        insertUpdateTransmittalGroupMemberDetails: 'Transmittal/InsertUpdateTransmittalGroupMemberDetails',
        insertUpdateTransmittalMsgDocDetails: 'Transmittal/InsertUpdateTransmittalMessageDocumentDetails',
        insertUpdateTransmittalDocDetails: 'Transmittal/InsertUpdateTransmittalDocumentDetails',
        insertUpdateTransmittalDocCopyDetails: 'Transmittal/InsertUpdateTransmittalDocumentCopyDetails',
        insertUpdateTransmittalDocElementDetails: 'Transmittal/InsertUpdateTransmittalElementDetails',
        sendTransmittalMailDetails: 'Transmittal/SendTransmittalMail',
        getTransmittalList: 'Transmittal/GetTransmittalDetails',
        getTransmittalReceiverDetails: 'Transmittal/GetTransmittalReceiverDetails',
        downloadAllAttachments: '/Transmittal/downloadAllAttachments',
        getTransmittalGroupMemberDetails: 'Transmittal/GetTransmittalGroupMemberDetails',
        getTransmittalDocumentDetails: 'Transmittal/GetTransmittalDocumentDetails',
        updateSignedDocumentsMsgId: 'Transmittal/UpdateSignedDocumentMsgId',
        getTransmittalMessageDetails: 'Transmittal/GetTransmittalMessageDetails'

    }

    constructor(private http: HttpClient, private restAPIService: RestApiService, private commonService: CommonService, private encryptDecryptService: EncryptDecryptService) {
    }

    public getTransmittalSerialNo(transmittalEleDetails: ITransmittalSerialNoInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.getTransmittalSerialNo, transmittalEleDetails);
    }

    public InsertUpdateTransmittalDetails(transmittalDetails: ITransmittalMsgInputModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalDetails, transmittalDetails);
    }

    public InsertUpdateTransmittalReceiverDetails(transmittalReceiverDetails: ITransmittalMsgReceiverInput): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalReceiverDetails, transmittalReceiverDetails);
    }

    public InsertUpdateTransmittalGroupMemberDetails(transmittalDistributionDetails: ITransmittalGroupMemberInput): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalGroupMemberDetails, transmittalDistributionDetails);
    }

    public InsertUpdateTransmittalMsgDocDetails(transmittalMsgDocDetails: ITransmittalMsgDocumentInput): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalMsgDocDetails, transmittalMsgDocDetails);
    }

    public InsertUpdateTransmittalDocDetails(transmittalDocDetails: ITransmittalDocumentInput): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalDocDetails, transmittalDocDetails);
    }

    public InsertUpdateTransmittalDocCopyDetails(transmittalDocCopyDetails: ITransmittalDocumentCopyInput): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalDocCopyDetails, transmittalDocCopyDetails);
    }

    public InsertUpdateTransmittalDocElementDetails(transmittalDocElementDetails: ITransmittalDocumentElementInput): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.insertUpdateTransmittalDocElementDetails, transmittalDocElementDetails);
    }

    public UpdateSignedDocumentsMessageId(signedDocumentsModel: ITransmittalSignedDocumentsModel): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.updateSignedDocumentsMsgId, signedDocumentsModel);
    }

    public SendTransmittalMail(transmittalMailDetails: ITransmittalMailDetails): Observable<any> {
        return this.restAPIService.new_POST(this.endPoints.sendTransmittalMailDetails, transmittalMailDetails);
    }

    public GetTransmittalList(transmittalMaster: ITransmittalMasterInput) {
        return this.restAPIService.new_POST(this.endPoints.getTransmittalList, transmittalMaster);
    }

    public GetTransmittalDocumentDetails(messageId: number) {
        let reqData: any = { "message_Id": messageId };
        return this.restAPIService.new_POST(this.endPoints.getTransmittalDocumentDetails, reqData);
    }

    public GetTransmittalMessageDetails(messageId: number)
    {
        let reqData: any = { "message_Id": messageId };
        return this.restAPIService.new_POST(this.endPoints.getTransmittalMessageDetails,reqData); 
    }

    public GetTransmittalGroupMemberDetails(messageId: number) {
        let reqData: any = { "message_Id": messageId };
        return this.restAPIService.new_POST(this.endPoints.getTransmittalGroupMemberDetails, reqData);
    }

    public GetTransmittalReceiverDetails(messageId: number) {
        let reqData: any = { "message_Id": messageId };
        return this.restAPIService.new_POST(this.endPoints.getTransmittalReceiverDetails, reqData);
    }

    public DownloadAllAttachments(projectId: number, messageId?: number, fileUploadLibrary?: number, downloadFileName?: string, task_ID?: string) {
        let _apiURL = environment.uriHost + this.endPoints.downloadAllAttachments;
        const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': 'Bearer ' + this.commonService.getJWT(),
            'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
        }
        let reqData: any = { "projectId": projectId, "messageId": messageId, "fileUploadLibrary": fileUploadLibrary, "downloadFileName": downloadFileName};
        return this.http.post(_apiURL, reqData, { 'headers': headers, responseType: 'blob' });
    }
}